import { AddressFormData } from '../types'

export const getDefaultAddressData = (installer?: string): AddressFormData => ({
  companyAddress: {
    addressAndHouseNumber: '',
    city: '',
    companyName: '',
    country: '',
    zipCode: '',
  },
  deviatingAddress: {
    addressAndHouseNumber: '',
    city: '',
    country: '',
    zipCode: '',
  },
  installer: {
    firstName: installer?.split(' ')[0] ?? '',
    lastName: installer?.split(' ').slice(1).join(' ') ?? '',
  },
  customerAddress: {
    addressAndHouseNumber: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    zipCode: '',
  },
  deviatingAddressEnabled: false,
  partnerNumber: '',
  partnerNumberEnabled: false,
  partnerNumberValid: false,
})

export const DEFAULT_WARRANTY = 2
export const EXTENDED_WARRANTY = 10
export const DEFAULT_GUARANTEE = 2
